import "./index.css";
import { clsx } from "clsx";
import type { IAlertProps } from "./types";
import { CircleCheck, Info, OctagonX, TriangleAlert } from "lucide-react";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { Typography } from "@/ui-kit";

const iconMap = {
  success: <CircleCheck size="1.25rem" />,
  warning: <TriangleAlert size="1.25rem" />,
  danger: <OctagonX size="1.25rem" />,
  info: <Info size="1.25rem" />,
};

const Alert = ({
  variant = "info",
  className,
  content,
  controls,
  title,
  icon,
  showIcon = true,
}: IAlertProps) => {
  const rootClass = clsx("nuco-alert", `nuco-alert--${variant}`, className);
  const { isMobile } = useBreakpoints();

  return (
    <div className={rootClass}>
      <div className="nuco-alert__title-row">
        {showIcon && (
          <div className="nuco-alert__icon">{icon || iconMap[variant]}</div>
        )}
        <Typography className="nuco-alert__title">{title}</Typography>
        {!isMobile && <div className="nuco-alert__controls">{controls}</div>}
      </div>
      <div className="nuco-alert__content">{content}</div>
      {isMobile && <div className="nuco-alert__controls">{controls}</div>}
    </div>
  );
};

export default Alert;
